<template>
  <div class="full-page-width relative locations" v-if="get_templates.entity.length > 0">
    <ConfirmationBar
      :showSavebar="showSavebar"
      @confirm="saveTemplate"
      @cancel="cancel"
    />
    <div class="add-button c-float m-b-25">
      <div class="flex-center float-left">
        <Btn
          @click.native="$router.go(-1)"
          class="light bordered empty d-inline-block m-r-15 fix-40"
          :icon="{
            name: 'arrowLeftBig',
            size: '20',
          }" />
        <p class="user-name">{{ `${$t('upload_template')}` }}</p>
      </div>
    </div>
    <div class="row m-b-40" v-if="get_user.is_admin">
      <div class="col-xs-4 text-box"></div>
      <div class="col-xs-8">
        <div class="card row p-40">
          <div class="col-xs-12">
            <InputSelect
              class="m-b-20"
              :multiSelect=true
              :preselected="accessibleForSubaccounts"
              :label="$t('accessible_for_accounts')"
              @change="selectAccessibleSubaccount"
              :rules="{required: true}"
              :options="getAllowedSubaccounts" />
          </div>
        </div>
      </div>
    </div>
    <div class="row m-b-40">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('edit_upload_template')"
          :text="$t('import-templates-view-info-text-config')"
          :btnText="$t('Delete template')"
          btnType="red"
          btnIcon="deleteForever"
          @action="deleteTemplate" />
      </div>
      <div class="col-xs-8">
        <div class="card row p-40">
          <div class="col-xs-4">
            <InputText
              class="m-b-40"
              :label="$t('Template name')"
              :rules="{required: true}"
              v-model="templateName" />
          </div>
          <div class="col-xs-4">
            <InputSelect
              class="m-b-40"
              :label="$t('type')"
              v-model="templateType"
              @change="setData"
              :rules="{required: true}"
              :options="getTemplateTypes" />
          </div>
          <div class="col-xs-4">
            <InputSelect
              class="m-b-40"
              :label="$t('file_type')"
              v-model="fileType"
              :rules="{required: true}"
              :options="get_template_field('template_file_type')" />
          </div>
          <div class="col-xs-4">
            <InputSelect
              :label="$t('Reading type')"
              v-model="readingType"
              :rules="{required: true}"
              :options="get_template_field('template_reading_type')" />
          </div>
          <div class="col-xs-4">
            <InputSelect
              :label="$t('Start row')"
              v-model="startRow"
              :rules="{required: true}"
              :options="rowData" />
          </div>
          <div class="col-xs-4">
            <InputSelect
              :label="$t('data_separator')"
              v-model="separator"
              :rules="{required: true}"
              :options="get_template_field('template_separator')" />
          </div>
        </div>
      </div>
    </div>
    <hr class="m-b-40"/>
    <div class="row" v-if="templateType !== ''">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('import-templates-view-info-text-map')"
          :title="$t('Select template fields')" />
      </div>
      <div class="col-xs-8">
        <div class="card row p-40">
          <div class="col-xs-6">
            <h2 class="c-title">{{ $t('header_text') }}</h2>
            <p class="m-b-40">{{ $t('Type in header text from your file') }}</p>
            <div
              v-for="(field, index) in get_templates.entity[0][templateType]"
              :key="`header-field-${index}`"
              class="m-b-40">
              <InputText
                v-if="field.required"
                placeholder="Type in header text from your file"
                v-model="requiredFields[field.field]" />
            </div>
            <div
              v-for="(item, index) in additionalFieldsData" :key="`add-field-${index}`"
              class="m-b-40">
              <InputText
                placeholder="Type in header text from your file"
                v-model="additionalFieldsData[index].file_column" />
            </div>
          </div>
          <div class="col-xs-6">
            <h2 class="c-title">{{ $t('Mapping field') }}</h2>
            <p class="m-b-40">{{ $t('Select field you will map your data to') }}</p>
            <div
              v-for="(field, index) in get_templates.entity[0][templateType]"
              :key="`mapping-field-${index}`"
              class="m-b-40">
              <InputText
                v-if="field.required"
                :value="field.field"
                :disabled="field.required" />
            </div>
            <div class="row"
              v-for="(item, index) in additionalFieldsData" :key="`add-field-${index}`">
              <div class="col-xs-9">
                <InputSelect
                  class="m-b-40"
                  :shouldTranslate="false"
                  v-model="additionalFieldsData[index].field_name"
                  @change="selectField(index, ...arguments)"
                  :options="additionalFieldsOptions" />
              </div>
              <div class="col-xs-3 pad-reduce">
                <Btn
                  @click.native="removeField(index, item)"
                  class="gray"
                  position="icon-pos-center"
                  :icon="{
                    name: 'deleteForever',
                    size: '18',
                  }"
                />
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <Btn
              v-if="!isAddDisabled"
              @click.native="addField"
              class="brand float-right"
              :icon="{
                name: 'plus',
                size: '18',
              }"
              :btnText="$t('add_field')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import ConfirmationBar from '@/components/global/confirmationBar';
import InfoTextBox from '@/components/global/infoTextBox';
import EventBus from '@/eventBus.js';
import formValidator from '@/mixins/formValidator';

export default {
  name: 'EditTemplate',
  mixins: [formValidator],
  components: { Btn, InputText, InputSelect, InfoTextBox, ConfirmationBar },
  data() {
    return {
      accessibleForSubaccounts: [],
      templateName: '',
      templateType: '',
      fileType: '',
      readingType: '',
      startRow: '',
      separator: '',
      requiredFields: {},
      additionalFieldsData: [],
      additionalFieldsOptions: [],
      // Confirmation savebar
      showSavebar: false,
      savebarEnabled: false,
    };
  },
  computed: {
    ...mapGetters([
      'get_templates',
      'get_template_field',
      'get_subaccounts',
      'get_user'
    ]),
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
    rowData() {
      const objArray = [];
      for (let ii = 1; ii < 20; ii++) {
        objArray.push({
          text: ii.toString(),
          value: ii,
        });
      }
      return objArray;
    },
    getTemplateTypes() {
      let result = [];
      for(const property in this.get_templates.entity[0]){
        if(['item_fields','customer_fields', 'shipment_fields'].includes(property)){
          result.push({
            text: property,
            value: property,
          });
        }
      };
      return result;
    },
    isAddDisabled() {
      return this.additionalFieldsOptions.length == this.additionalFieldsData.length;
    },
  },
  created() {
    this.$store.dispatch('GET_TEMPLATES').then(() => {
      this.$store.dispatch('GET_TEMPLATE_BY_ID', this.$route.params.id).then((res) => {
        this.accessibleForSubaccounts = res.items.accessible_for_subaccounts || [];
        this.templateName = res.items.name || '';
        this.templateType = res.items.template_type || '';
        this.fileType = res.items.template_file_type || '';
        this.readingType = res.items.template_reading_type || '';
        this.startRow = res.items.start_from_row || '';
        this.separator = res.items.template_separator || '';

        this.setData(res.items.template_type);

        res.items.fields_json.forEach((item) => {
          let setField = true;
          this.additionalFieldsOptions.forEach((option, index) => {
            if(option.value == item.field_name) {
              this.additionalFieldsOptions[index].selected = true;
              this.additionalFieldsData.push({
                index: this.additionalFieldsData.length,
                field_name: item.field_name,
                file_column: item.file_column
              });
              setField = false;
            }
          })
          if(setField) this.requiredFields[`${item.field_name}`] = item.file_column;
        })
        this.$nextTick(() => {
          this.savebarEnabled = true;
        })
      });
    });
  },
  methods: {
    selectAccessibleSubaccount(val) {
      if(val.length > 0){
        this.accessibleForSubaccounts = val;
      }
    },
    deleteTemplate() {
      this.$store.dispatch('DELETE_TEMPLATE_BY_ID', this.$route.params.id).then(() => {
        this.$router.push('/settings/platform/import-templates');
      });
    },
    cancel() {
      this.showSavebar = false;
    },
    saveTemplate(){
      EventBus.$emit('checkSubmitErrors');
      if(this.get_user.is_admin){
        if(this.accessibleForSubaccounts.length == 0) return;
        this.accessibleForSubaccounts = this.accessibleForSubaccounts.filter((val) => this.get_user.accessible_subaccounts_array.indexOf(String(val)) > -1);
      }
      // CHEK FORM
      let formWithValidators = [
        {
          formFeild:'templateName',
          value: this.templateName,
          validators:{required: true}
        },
        {
          formFeild:'templateType',
          value: this.templateType,
          validators:{required: true}
        },
        {
          formFeild:'fileType',
          value: this.fileType,
          validators:{required: true}
        },
        {
          formFeild:'readingType',
          value: this.readingType,
          validators:{required: true}
        },
        {
          formFeild:'startRow',
          value: this.startRow,
          validators:{required: true}
        },
        {
          formFeild:'separator',
          value: this.separator,
          validators:{required: true}
        },
      ]

      if(!this.validateInput(formWithValidators)){
        this.$store.dispatch('EDIT_TEMPLATE', {
          id: this.$route.params.id,
          form: {
            accessible_for_subaccounts: this.accessibleForSubaccounts,
            name: this.templateName,
            template_type: this.templateType,
            template_reading_type: this.readingType,
            template_separator: this.separator,
            template_file_type: this.fileType,
            sheet_number: 1,
            start_from_row: this.startRow,
            fields_json: this.spreadFields(),
          },
        }).then(() => {
          this.showSavebar = false;
        })
      }
    },
    spreadFields() {
      const fields = [];
      for(const item in this.requiredFields) {
        fields.push({
          field_name: item,
          file_column: this.requiredFields[item],
        });
      }

      this.additionalFieldsData.forEach((obj, i) => {
        fields.push({
          field_name: obj.field_name,
          file_column: obj.file_column,
        });
      });

      return fields;
    },
    addField() {
      this.additionalFieldsData.push({
        index: this.additionalFieldsData.length,
        file_column: '',
        field_name: ''
      });
    },
    removeField(index, item) {
      for(const prop in this.additionalFieldsOptions){
        if( this.additionalFieldsOptions[prop].value == this.additionalFieldsData[index].field_name){
          this.additionalFieldsOptions[prop].selected = false;
        }
      }

      this.additionalFieldsData.splice(index, 1);
    },
    selectField(index, val) {
      //Give a little time to v-model to do the stuff
      setTimeout(() => {
        //Reset additional fields options list
        for(const prop in this.additionalFieldsOptions){
          if(this.additionalFieldsOptions[prop].value != val){
            this.additionalFieldsOptions[prop].selected = false;
          }

          //Mark currently selected field
          if (this.additionalFieldsOptions[prop].value === val){
            this.additionalFieldsOptions[prop].selected = true;
          }

          //Mark already added fields as selected
          for (let i = 0; i < this.additionalFieldsData.length; i++) {
            if (this.additionalFieldsData[i].field_name === this.additionalFieldsOptions[prop].value) {
              this.additionalFieldsOptions[prop].selected = true;
            }
          }
        }
      }, 50)
    },
    setData(val) {
      this.requiredFields = new Object();
      this.additionalFieldsOptions = new Array();
      const obj = this.get_templates.entity[0][val];
      for(let ii=0; ii < obj.length; ii++){
        if( obj[ii].required ){
          this.$set(this.requiredFields, [obj[ii].field], '');
        } else {
          this.additionalFieldsOptions.push({
            text: obj[ii].field,
            value: obj[ii].field,
            selected: false,
          });
        }

      }
    },
  },
  watch: {
    'accessibleForSubaccounts': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'templateName': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'templateType': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'fileType': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'startRow': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'separator': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'requiredFields': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'additionalFieldsData': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
  },
}
</script>
